import React, { useEffect, useState } from "react";
import { Send, ExternalLink, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { adminApi, errText } from "./api";
import { Btn, Card } from "./ui";

const Row = ({ label, value, href, testId }) => (
  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 py-2 border-b border-[#1c5f35]/60 last:border-0">
    <span className="text-xs uppercase tracking-wide text-emerald-50/50 sm:w-40 shrink-0">{label}</span>
    {href ? (
      <a data-testid={testId} href={href} target="_blank" rel="noreferrer" className="text-sm text-[#ffb224] hover:underline break-all inline-flex items-center gap-1">{value} <ExternalLink size={12} /></a>
    ) : (
      <span data-testid={testId} className="text-sm text-emerald-50 break-all">{value}</span>
    )}
  </div>
);

export const IndexingCard = () => {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => adminApi.indexingStatus().then(setSt).catch((e) => toast.error(errText(e)));
  useEffect(() => { load(); }, []);

  const submit = async () => {
    setBusy(true);
    try {
      const r = await adminApi.indexingSubmitAll();
      r.ok ? toast.success(`${r.count} pages IndexNow ko bhej diye`) : toast.error(`IndexNow: ${r.message}`);
      await load();
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };

  if (!st) return null;
  const last = st.last || {};
  return (
    <Card title="Auto Indexing (Sitemap + IndexNow)" action={<Btn variant="ghost" onClick={load} data-testid="indexing-refresh"><RefreshCw size={14} /></Btn>}>
      <p className="text-sm text-emerald-50/70 mb-3">Sitemap live DB se banta hai - naya game add/edit karte hi sitemap update hota hai aur Bing/Yandex ko IndexNow ping jata hai. Google ke liye Search Console me sitemap URL submit karein.</p>
      <Row label="Total pages" value={`${st.totalUrls} URLs`} testId="indexing-total" />
      <Row label="Sitemap" value={st.sitemapUrl} href={st.sitemapUrl} testId="indexing-sitemap-link" />
      <Row label="Robots.txt" value={st.robotsUrl} href={st.robotsUrl} testId="indexing-robots-link" />
      <Row label="IndexNow key" value={st.indexNowKey} testId="indexing-key" />
      <Row label="Last submit" value={last.at ? `${last.ok ? "OK" : "Failed"} - ${last.count} URLs - ${new Date(last.at).toLocaleString()} (${last.message})` : "Abhi tak nahi"} testId="indexing-last" />
      <div className="flex justify-end mt-4">
        <Btn data-testid="indexing-submit-all" onClick={submit} disabled={busy}><Send size={15} /> {busy ? "Submitting..." : "Submit all pages now"}</Btn>
      </div>
    </Card>
  );
};
